import React from 'react';
import { CustomCheckbox } from 'components/base/checkbox';
import { ISelectOption } from 'components/base/model/ISelect';

export function renderOptionWithCheckbox(
	option: ISelectOption,
	isChecked?: boolean,
) {
	return (
		<CustomCheckbox
			name={option.title as string}
			label={option.title as string}
			checked={isChecked}
			disabled
		/>
	);
}
